export const STORAGE_KEY = 'jwt_access_token';

export const REFRESH_TOKEN = 'refreshToken';
export const Token = 'token';

export const USER = 'user';

export const ErrorCodes = {
  INTERNAL_SERVER_ERROR: 'CFE000001',
  GENERAL_ERROR: 'CFE000002',
  USER_NOT_FOUND: 'CFE000003',
  EMAIL_EXISTS: 'CFE000004',
  ENABLE_OWN_MFA_BEFORE_ORG_MFA_POLICY: 'CFE000020',
  CONTACT_PERSON_INTEGRATION_DELETE_FORBIDDEN: 'CFE000045',
};
